@if (showDialog()) {
  <div class="dialog confirm-dialog">
    @if (showCloseButton() && !data?.hideIcon) {
      <button
        mat-button
        mat-dialog-close
        class="dialog__close"
        (click)="onClose()"
        >
        <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'shared.close' | translate }}</span>
      </button>
    }
    @if (!data?.hideIcon) {
      <div mat-dialog-title>
        <h1>{{ 'shared.alert' | translate }}</h1>
      </div>
    }
    @if (data?.hideIcon && data?.header) {
      <div mat-dialog-title>
        <h1>{{ data.header }}</h1>
      </div>
    }
    <div mat-dialog-content class="confirm-container" [ngClass]="{ 'email-list-mode': data?.emailListWithNames?.length > 0 }">
      <div class="viewmode">
        @if (!data?.hideIcon) {
          <mat-icon><em class="fa fa-exclamation-triangle"></em></mat-icon>
        }
        <div class="alert-msgs">
          @if (!data.duplicateAlert) {
            <span class="message">{{ data.message }}</span>
          }
          @if (data?.emailListWithNames?.length > 0) {
            <div class="email-list">
              @for (item of data.emailListWithNames; track item.email; let i = $index;let last = $last) {
                <div class="email-item">        
                  <div
                    class="circle-container"
                    [ngStyle]="{ 'background-color': i | getColor }"
                  >                   
                    <span>{{((getFirstName(item?.name) || '-')[0] + (getLastName(item?.name) || '-')[0]) | uppercase}}</span>
                  </div>
                  <div class="email-content">
                    <span class="name-text">{{ item.name }}</span>
                    <span class="email-text">{{ item.email }}</span>
                  </div>
                </div>

                @if (!last) {
                  <mat-divider></mat-divider>
                }
              }
            </div>
          } 
          @if (data?.multipleMessages?.length > 0) {
            @for (message of data.multipleMessages; track message) {
              <span class="message">{{ message }}</span>
            }
          }
          @if (data.leaveMessage) {
            <span class="message">{{ data.leaveMessage }}</span>
          }
          @if (data.rememberMyChoiceDialogId) {
            <div>
              <mat-checkbox [(ngModel)]="rememberChoice">
                {{ data.doNotRemindMeText }}
              </mat-checkbox>
            </div>
          }
          @if (data.checkbox) {
            <div>
              <mat-checkbox [(ngModel)]="checkboxValue">
                {{ data.checkbox.label }}
              </mat-checkbox>
            </div>
          }
          @if (data.duplicateAlert) {
            <div>
              @if (data.duplicateAlert.entity === 'property') {
                <span>
                  {{ 'recordsSearch.duplicateRecordExists.' + data.duplicateAlert.entity + '.withExistingId' | translate }}
                  <miq-goes-to-record
                    [id]="data.duplicateAlert.existingId"
                    [type]="data.duplicateAlert.entity"
                    target="_blank"
                    >{{ data.duplicateAlert.existingId }}</miq-goes-to-record
                    >
                  </span>
                }
                <span>
                  {{ 'recordsSearch.duplicateRecordExists.' + data.duplicateAlert.entity + '.additionalInfo' | translate }}
                </span>
              </div>
            }
          </div>
        </div>
        <div mat-dialog-actions>
          @if (data.cancelText) {
            <button (click)="selectOption(false)" class="button button--outlined">{{ data.cancelText }}</button>
          }
          @if (!data.swap) {
            <button (click)="selectOption(true)" class="button" cdkFocusInitial>{{ data.confirmText }}</button>
          }
          @if (data.swap) {
            <button (click)="selectOption(false)" class="button" cdkFocusInitial>{{ data.confirmText }}</button>
          }
        </div>
      </div>
    </div>
  }
